import {
  Box,
  Flex,
  Heading,
  IconButton,
  Image,
  LinkBox,
  LinkOverlay,
  Text,
  VStack,
} from '@chakra-ui/react';
import * as React from 'react';

import { ImageFallback } from '@/imports/ui/chakra/components/ImageFallback';
import { XIcon } from '@/imports/ui/chakra/feather';

export const DefaultPreview: React.FC<{
  thumbnailUrl: string;
  title: string;
  providerUrl: string;
  href: string;
  target: string;
  description: string;
  canEdit: boolean;
  onCloseClick: () => void;
}> = (props) => (
  <LinkBox position="relative">
    {props.canEdit && (
      <IconButton
        aria-label="hide preview"
        colorScheme="gray"
        size="xs"
        borderRadius="full"
        position="absolute"
        top={4}
        right={4}
        zIndex="1"
        onClick={props.onCloseClick}
        icon={<XIcon />}
      />
    )}

    <Flex border="1px" borderColor="gray.100" borderRadius="lg"
      direction={['column', 'row']} 
      overflow="hidden"           
      w="100%"   
    >
      <Image
        src={props.thumbnailUrl}
        alt={props.title}
        h="141px"
        minW={['unset', 'unset', '200px']}
        fit="cover"
        borderTopLeftRadius="lg"
        borderBottomLeftRadius="lg"
        fallback={
          <ImageFallback
            aspectRatio="unset"
            h="141px"
            minW={['64px', '128px', '200px']}
          />
        }
      />
      <VStack align="flex-start" p="4">
        <Box color="gray.500" fontSize="12px" noOfLines={1}>
          {props.providerUrl}
        </Box>
        <LinkOverlay
          href={props.href}
          target={props.target}
          wordBreak="break-all"
        >
          <Heading as="h5" size="sm" noOfLines={1} color="gray.700">
            {props.title}
          </Heading>
        </LinkOverlay>
        <Text color="gray.500" noOfLines={2} wordBreak="break-all">
          {props.description}
        </Text>
      </VStack>
    </Flex>
  </LinkBox>
);
